/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// **** Function to hide the sticky buy button whenver the mini cart is shown **** //
document.addEventListener('DOMContentLoaded', function() {
  var cartToggleElement = document.querySelector('.header__action-item-link.header__cart-toggle');
  var stickyBuyButton = document.querySelector('.sticky-buy-button');

  function handleBuyButtonVisibility() {
    if (window.innerWidth <= 700) {
      if (stickyBuyButton && cartToggleElement) {
        var isExpanded = cartToggleElement.getAttribute('aria-expanded') === 'true';
        stickyBuyButton.style.display = isExpanded ? 'none' : 'block';
      }
    } else {
      if (stickyBuyButton) {
        stickyBuyButton.style.display = 'none';
      }
    }
  }

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
        handleBuyButtonVisibility();
      }
    });
  });

  if (cartToggleElement) {
    observer.observe(cartToggleElement, {
      attributes: true
    });
  }

  // Listen for window resize events
  window.addEventListener('resize', handleBuyButtonVisibility);

  // Initial check
  handleBuyButtonVisibility();
}); 


function calc() {
  if (document.getElementById("policyText").checked) {
    let cartBtnContainer = document.getElementById("cartButtonContainer");
    cartBtnContainer.classList.remove("hideContainer");
  } else {
    let cartBtnContainer = document.getElementById("cartButtonContainer");
    cartBtnContainer.classList.add("hideContainer");
  }
}

$(".product-meta-top").each(function () {
  var productMeta = $(this)
    .find(".productMetaValues")
    .clone()
    .addClass("product-meta-bottom");

  $(".estimated_time.withDays").after(productMeta);
});

// function addToCartOk(quantity){
//     let el = document.getElementById("customAjax");
//     el.dispatchEvent(new CustomEvent('cart:refresh', {
//       bubbles: true
//     }));
// 	//$('#cart-number').replaceWith("<a href="/cart" id="cart-number">View cart (" + quantity + ")</a>");
// }

/// **** ADD ONS SECTION WITH CAR REG  **** ///
$(document).ready(function () {
  var carregWrapper = $("#carreg-wrapper");
  var addonProducts = $(".addons-product");
  var addonsCheckboxes = $(".addons-checkbox");

  function handleRegistrationPlateChange() {
    var selectedAddonId = 45443347218747;
    var selectedAddonInputName = "addons[" + selectedAddonId + "]";

    var isSelected = addonProducts.toArray().some(function (addonProduct) {
      var addonCheckbox = $(addonProduct).find(".addons-checkbox");
      return (
        addonCheckbox.prop("checked") &&
        addonCheckbox.attr("name") === selectedAddonInputName
      );
    });

    carregWrapper.css("display", isSelected ? "block" : "none");
  }

  // Attach click event listener to addon-products
  addonProducts.on("click", function (event) {
    var addonCheckbox = $(this).find(".addons-checkbox");
    if (addonCheckbox.length > 0) {
      addonCheckbox
        .prop("checked", !addonCheckbox.prop("checked"))
        .trigger("change");
      handleRegistrationPlateChange(); // Call the handler immediately
    }
  });

  // Attach change event listener to checkboxes
  addonsCheckboxes.on("change", handleRegistrationPlateChange);
});

// Add validation to registration plate field
var regPlateInput = document.getElementById("Personalisation");

if (regPlateInput !== null && typeof regPlateInput !== "undefined") {
  regPlateInput.addEventListener("input", function () {
    var regPlateValue = regPlateInput.value;

    regPlateValue = regPlateValue.replace(/[^a-zA-Z0-9\s]/g, "");

    regPlateValue = regPlateValue.slice(0, 8);

    regPlateInput.value = regPlateValue;
  });
}

/// **** Add border to selected addon **** ///
function toggleBorder(element) {
  const addonsProduct = element.closest(".accessories-product");
  if (addonsProduct) {
    const checkbox = addonsProduct.querySelector(".addons-checkbox");
    if (checkbox) {
      checkbox.checked = !checkbox.checked;
      if (checkbox.checked) {
        addonsProduct.classList.add("checked-border");
      } else {
        addonsProduct.classList.remove("checked-border");
      }
    }
  }
}

/// **** UPSELL MODAL **** ///

document.addEventListener("DOMContentLoaded", function () {
  // select the open-btn button
  var openBtn1 = document.getElementById("open-btn");
  var openBtn2 = document.getElementById("open-btn-2");
  // select the modal-background
  var modalBackground = document.getElementById("modal-background");
  // select the close-btn
  var closeBtn = document.getElementById("close-btn");

  // Add an event listener to reset the form elements before unloading the page
  window.addEventListener("beforeunload", function () {
    resetFormElements();
  });

  // Checks if the elements exist before adding event listeners
  if (openBtn1 && openBtn2 && modalBackground) {
    // Add an event listener to show the modal when the user clicks open-btn
    openBtn1.addEventListener("click", function () {
      modalBackground.style.display = "block";
    });

    openBtn2.addEventListener("click", function () {
      modalBackground.style.display = "block";
    }
    );
  }

  if (closeBtn && modalBackground) {
    // Add an event listener to hide the modal when the user clicks close-btn
    closeBtn.addEventListener("click", function () {
      resetFormElements();
      // hides the modal
      modalBackground.style.display = "none";
    });
  }
  // hides the modal when the user clicks outside the modal
  window.addEventListener("click", function (event) {
    // check if the event happened on the modal-background
    if (event.target === modalBackground) {
      resetFormElements();
      // hides the modal
      modalBackground.style.display = "none";
    }
  });
});

// Function to reset form elements
function resetFormElements() {
  // Reset select elements to their initial state
  var warrantySelect = document.getElementById("warranty-select");
  if (warrantySelect) {
    warrantySelect.value = "";
  }

  var batterySelect = document.getElementById("battery-select");
  if (batterySelect) {
    batterySelect.value = "";
  }

  var personalisationInput = document.getElementById("Personalisation");
  if (personalisationInput) {
    personalisationInput.value = "";
  }

  // Reset checkboxes to their initial state and remove the checked-border class
  var checkboxes = document.querySelectorAll(".addons-checkbox");
  checkboxes.forEach(function (checkbox) {
    checkbox.checked = false;
    // Remove the checked-border class from the parent .accessories-product div
    var parentProduct = checkbox.closest(".accessories-product");
    if (parentProduct) {
      parentProduct.classList.remove("checked-border");
    }
  });

  // ensure the addons checkbox is unchecked if a different page is loaded
  var addonsCheckbox = document.getElementById("addons-checkbox");
  if (addonsCheckbox) {
    addonsCheckbox.checked = false;
  }

  // Reset variables to their initial values if originalProductPrice exists
  if (typeof originalProductPrice !== "undefined" ) {
    totalSelectedPrice = originalProductPrice;

    // Update the total price element with the reset price
    totalPriceElement.textContent = formatPrice(totalSelectedPrice);
  }
}
